import { render, staticRenderFns } from "./IncidencesCardItem.vue?vue&type=template&id=2fa14522&"
import script from "./IncidencesCardItem.vue?vue&type=script&lang=js&"
export * from "./IncidencesCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports